import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Page } from "../shared/models/Page";
import { CesionFile } from "../models/Cesion/CesionFile";
import { Traza } from "../models/Traza";
import { Cesion } from "../models/Cesion/Cesion";
import { TrazaCesion } from "../models/Cesion/TrazaCesion";
import { DteEmitido } from "../models/Dte/DteEmitido";
import { DetalleCesion } from "../models/Cesion/DetalleCesion";
import { UpdateCesionRequest } from "../models/Cesion/UpdateCesionRequest";
import { CesionFilter } from "../models/Cesion/CesionFilter";

@Injectable({
	providedIn: "root",
})
export class CesionService {
	private REST_API_SERVER = environment.backend_server + "/Cesion";
	private auth = {};
	constructor(private http: HttpClient) {}

	public getDataByPage(filtro: CesionFilter, page: Page): Observable<PagedResponse<Cesion>> {
		return this.http.get<PagedResponse<Cesion>>(
			this.REST_API_SERVER +
				"/list/filter?nombrePersonaAutorizada=" +
				(filtro.nombrePersonaAutorizada != undefined ? filtro.nombrePersonaAutorizada : "") +
				"&RutPersonaAutorizada=" +
				(filtro.rutPersonaAutorizada != undefined ? filtro.rutPersonaAutorizada : "") +
				"&Folio=" +
				(filtro.folio != undefined ? filtro.folio : "") +
				"&EmisorId=" +
				(filtro.emisorId != undefined ? filtro.emisorId : "") +
				"&fechaDesde=" +
				(filtro.fechaDesde != undefined ? filtro.fechaDesde : "") +
				"&fechaHasta=" +
				(filtro.fechaHasta != undefined ? filtro.fechaHasta : "") +
				"&pageNumber=" +
				page.pageNumber +
				"&pageSize=" +
				page.pageSize
		);
	}

	getXml(cesionId: string): Observable<Response<CesionFile>> {
		return this.http.get<Response<CesionFile>>(this.REST_API_SERVER + "/xml?cesionId=" + cesionId);
	}

	getTrace(cesionId: string): Observable<Response<TrazaCesion[]>> {
		return this.http.get<Response<TrazaCesion[]>>(this.REST_API_SERVER + "/trazabilidad?cesionId=" + cesionId);
	}

	getDteCesion(cesionId: string): Observable<Response<DteEmitido>> {
		return this.http.get<Response<DteEmitido>>(this.REST_API_SERVER + "/getDteCesion?cesionId=" + cesionId);
	}
	getDetalleCesion(cesionId: string): Observable<Response<DetalleCesion[]>> {
		return this.http.get<Response<DetalleCesion[]>>(this.REST_API_SERVER + "/detalles?cesionId=" + cesionId);
	}
	resendCesion(request: UpdateCesionRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/updateSiiStatus", request);
	}
}
